import { render, staticRenderFns } from "./TheUser.vue?vue&type=template&id=479d881d"
import script from "./TheUser.vue?vue&type=script&lang=js"
export * from "./TheUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports